import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowRight, Home } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const productId = params.get("product");
  const backTo = productId ? `/products#${productId}` : "/products";

  return (
    <main
      data-testid="payment-cancel-page"
      className="min-h-screen bg-[#040812] pt-32 pb-24 px-6 relative overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-20 pointer-events-none" />

      <div className="relative max-w-2xl mx-auto">
        <div className="bg-[#0B132B]/50 border border-white/10 p-8 md:p-12">
          <XCircle size={28} className="text-red-500" strokeWidth={1.5} />
          <span className="overline mt-8 block">Checkout cancelled</span>
          <h1 className="mt-4 font-display text-white text-3xl md:text-4xl tracking-tighter font-light leading-tight">
            No charge was made.
          </h1>
          <p className="mt-4 text-slate-400 text-sm md:text-base leading-relaxed">
            You cancelled the pre-booking checkout before it completed. Your
            pre-booking slot is still available — you can try again anytime.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to={backTo}
              className="inline-flex items-center justify-center gap-2 bg-red-500 hover:bg-red-600 text-white font-medium px-6 py-3.5 rounded-sm transition-colors"
            >
              Return to Products
              <ArrowRight size={14} />
            </Link>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 border border-white/15 hover:border-white text-white text-sm px-6 py-3.5 rounded-sm transition-colors"
            >
              <Home size={14} /> Back to home
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
